import { SearchFilter, SearchFilterOptionRange } from "../../../redux-magic/sub-interfaces/search-types";

export const _k_balconies: SearchFilter = {
	id: "balconies",
	title: "Balconies",
	level: 3,
	index: 10,
	presentation_type: "checkboxes",
	multi: true,
	affects: [],
	affected_by: ["property_type"],
	priority: 3,
	is_advanced: false,
	included_in_search_bar: false,
	option_type: "range",
	possible_options: [
		{
			id: "balconies",
			title: "Balconies",
			value: {
				min: 0,
				max: 0,
				unlock_max: true,
			},
		},
	] as Array<SearchFilterOptionRange>,
	active_options: [
		{
			id: "balconies",
			title: "Balconies",
			value: {
				min: 0,
				max: 0,
				unlock_max: true,
			},
		},
	] as Array<SearchFilterOptionRange>,
	selected_options: [] as Array<SearchFilterOptionRange>,
	db_collection: "properties",
	db_field: "balconies",
	is_visible: false,
	is_applied: false,
	is_accordion_open: true,
};
